'use strict';

var $ = require('jquery');
var util = require('../utils/util');
var addToCart = require('../pages/product/addToCart');
var page = require('../components/page');
var progress = require('../utils/progress');
var offcanvasdialog = require('../components/offcanvasdialog');
var showpassword = require('../utils/showpassword');
var validator = require('../utils/validator');
var inputfields = require('../utils/inputfields');
var uniform = require('../components/uniform');
const friendlyCaptcha = require('../widgets/friendlyCaptcha');
const captcha = require('../spam/captcha');

exports.init = function (target) {
    var $form = $(target).closest('form');
    var isPreOrderFlyin = $(target).hasClass('pre-order-button');
    var isMemberExclusivesFlyin = $(target).hasClass('member-exclusives') || $(target).hasClass('member-shop');
    var isCartFlyin = $(target).hasClass('dhl-sign-in-link');

    var memberShopFlyin = offcanvasdialog.init(false, {
        overlay: true,
        overlayClasses: 'is-active',
        additionalClass: 'member-shop-fly-in'
    });

    var flyinUrl = Urls.memberShopFlyin;

    if (isPreOrderFlyin || isMemberExclusivesFlyin) {
        flyinUrl = util.appendParamToURL(Urls.memberShopFlyin, 'preorderFlyin', 'true');
    }

    memberShopFlyin.loadContent(flyinUrl, function () {
        var memberShopRegisterLoaded = false;
        var isWishlist = $('#wishlistpage').length > 0;
        var isMacOs = $('html').hasClass('mac-os');
        var ocdFlyin;

        memberShopFlyin.show();
        showpassword.init();
        validator.init();
        inputfields.init();
        uniform();

        $('body').trigger('membersonlyflyin::membersonlyflyinLoaded');

        // The following fix is provided because of scrolling issues on mac
        ocdFlyin = $('.ocd-flyin.active');
        if (isWishlist && isMacOs && ocdFlyin.length > 1) {
            ocdFlyin.eq(0).hide();
            ocdFlyin.eq(1).animate(
                {
                    right: 0
                },
                600
            );
        }

        // The following fix is provided because of the Android bug with 'overflow: hidden' on the parent container and scrollable container with a form inside
        $('.member-shop-fly-in input').on('focus click tap', function () {
            if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
                $('html').addClass('ocd-initial-overflow');
                setTimeout(function () {
                    $('html').removeClass('ocd-initial-overflow');
                }, 500);
            }
        });

        const registerBtn = memberShopFlyin.$flyin.find('form .button-trans.frc-captcha-btn');

        memberShopFlyin.$flyin.find('form').on('submit', function (event) {
            var $memberShopForm = $(event.target);
            var action = $memberShopForm.attr('action');
            var method = $memberShopForm.attr('method');

            var $termsAndConditionsBtn = $('.create-account-terms');
            util.toggleFormSubmitEnabled($termsAndConditionsBtn);

            $(document).on('change', $termsAndConditionsBtn, function () {
                util.toggleFormSubmitEnabled($termsAndConditionsBtn);
            });

            event.preventDefault();

            if (!memberShopRegisterLoaded && $memberShopForm.attr('id') === 'RegistrationForm') {
                memberShopRegisterLoaded = true;
                $memberShopForm
                    .find('fieldset')
                    .children()
                    .not('.create-account-title, script')
                    .addClass('show-register-field');

                friendlyCaptcha.init('#RegistrationForm .frc-captcha');

                if (registerBtn && registerBtn.length) {
                    registerBtn.attr('disabled', true);
                }

                return;
            }

            var validate = $memberShopForm.valid();

            if (validate) {
                progress.show($('.member-shop-fly-in .ocd-content'));
                $.ajax({
                    url: action,
                    method: method,
                    data: $memberShopForm.serialize(),
                    dataType: 'json',
                    success: function (response) {
                        if (!response.error) {
                            if (isPreOrderFlyin || isMemberExclusivesFlyin) {
                                sessionStorage.setItem('signInToBuyLogin', 'true');
                                sessionStorage.setItem('signInToBuyProduct', $form.find('input[name="pid"]').val());
                                if (response.registration) {
                                    var regSource = isPreOrderFlyin ? 'preOrderFlyIn' : 'outletFlyin';
                                    sessionStorage.setItem('regSource', regSource);
                                }
                                page.refresh();
                            } else if (isCartFlyin) {
                                page.refresh();
                            } else {
                                if (response.registration) {
                                    sessionStorage.setItem('regSource', 'membersOnlyFlyIn');
                                }
                                addToCart.addItemToCart($form).then(function () {
                                    page.refresh();
                                });
                            }
                        } else {
                            $memberShopForm.find('.message').remove();
                            $memberShopForm.find('.validation-error').removeClass('validation-error');

                            if (response.error && response.error !== 'no-message') {
                                $memberShopForm.prepend(
                                    $('<div />', {
                                        class: 'message error-form',
                                        text: response.error
                                    })
                                );

                                for (var key in response) {
                                    if (key.startsWith('ff_')) {
                                        var elementId = key.replace('ff_', 'dwfrm_');
                                        var errorMessage = response[key];
                                        var $element = $('#' + elementId);

                                        if ($element.length) {
                                            var errorElementId = elementId + '-error';
                                            var $elementFormRow = $element.closest('.form-row');
                                            var $errorContainer = $('<div class="error-msg" />');

                                            $errorContainer.append(
                                                '<div id="' +
                                                    errorElementId +
                                                    '" class="error-msg-inner">' +
                                                    errorMessage +
                                                    '</div>'
                                            );
                                            $element.attr('aria-describedby', errorElementId);
                                            $element.attr('aria-invalid', 'true');
                                            $elementFormRow.addClass('validation-error');
                                            $elementFormRow.append($errorContainer);
                                        }
                                    }

                                    if (key.startsWith('cb_') && response[key]) {
                                        var $element = $('#' + key.replace('cb_', 'dwfrm_'));
                                        var $elementFormRow = $element.closest('.form-row');
                                        $elementFormRow.addClass('validation-error');
                                    }
                                }

                                captcha.resetCaptcha($memberShopForm[0]);
                            }
                        }

                        if (response.passwordMinLength) {
                            const $passwordField = $memberShopForm.find('.password-show-container');

                            $passwordField.append(
                                $('<div />', {
                                    class: 'error-msg'
                                }).append(
                                    $('<div />', {
                                        class: 'error-msg-inner',
                                        text: response.passwordMinLength
                                    })
                                )
                            );
                        }
                    },
                    error: err => captcha.resetCaptcha($memberShopForm[0]),
                    complete: () => progress.hide()
                });
            }
        });

        if (registerBtn && registerBtn.length) {
            registerBtn.removeAttr('disabled');
        }
    });
};
